///include /assets/js/app/p/card-capture.js
class CardCaptureSagePay extends CardCaptureDriver {
    static get type() {
        return "sagepay"
    }
    get canCapture() {
        return !!(
            CheckoutInfo.inst.info &&
            CheckoutInfo.inst.info.card.type == CardCaptureSagePay.type && //
            CheckoutInfo.inst.info.card.captureKey
        )
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        /** @type {HTMLFormElement} */
        const pf = document.querySelector("#payment-form")
        if(pf && !pf.getAttribute("action")) {
            const action = safeLocalUrl(return_url, null)
            if(action) {
                pf.action = action
            } else {
                throw new Error(`Invalid return URL: ${return_url}`)
            }
        }
        if(!from_vue) {
            /** @type {HTMLButtonElement} */
            //@ts-ignore
            const submit = document.querySelector(
                "#modal-add-card button.btn-primary"
            )
            submit.addEventListener(
                "click",
                async () => {
                    await this.submitForm()
                    location.href = "/account/billing-details"
                }
            )
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        if(!pf.getAttribute("action")) {
            throw new Error(`No form action, please see errors`)
        }
        const ci = CheckoutInfo.inst
        await ci.preloadSingle("info")
        await Site.require_once("https://pi-test.sagepay.com/api/v1/js/sagepay.js")

        this.tokenisedPromise = new Promise((resolve, reject) => {
            this.tokenisedResolve = resolve
            this.tokenisedReject = reject
        })
        $(pf).parents(".modal")
            .on("show.bs.modal", () => {
                const msk = CheckoutInfo.inst.info.card.captureKey
                this.sagepay = sagepayCheckout({
                    containerSelector: "#payment-section",
                    merchantSessionKey: msk,
                    /**
                     *
                     * @param {{success: boolean, error: *, cardIdentifier?: string}} result
                     */
                    onTokenise: async result => {
                        if(result.success) {
                            /** @type {HTMLFormElement} */
                            const pf = document.querySelector("#payment-form")
                            await $.ajax({
                                method: "post",
                                url: pf.action,
                                data: {
                                    token: JSON.stringify({
                                        cardIdentifier: result.cardIdentifier,
                                        merchantSessionKey: msk,
                                    }),
                                }
                            })
                            this.tokenisedResolve()
                        } else {
                            this.tokenisedReject()
                            throw new Error(
                                `Tokenise error: ${JSON.stringify(result)}`
                            )
                        }
                    }
                })
            })
            .on("hidden.bs.modal", () => this.sagepay.destroy())
    }
    async submitForm() {
        const msk = CheckoutInfo.inst.info.card.captureKey
        this.sagepay.tokenise({
            merchantSessionKey: msk,
        })
        await this.tokenisedPromise
        CheckoutInfo.inst.reload(["info"]) // The capture key is thrown away
        this.tokenisedPromise = new Promise((resolve, reject) => {
            this.tokenisedResolve = resolve
            this.tokenisedReject = reject
        })
    }
}
CardCaptureDriver.add(CardCaptureSagePay)